export const regionsNvilles = [
  {
    address: "شارع كمال الزبدي، حي الرياض، 10100، الرباط الهاتف: 0600004219/22",
    name: "الرباط سلا القنيطرة",
    villes: [
      "سلا",
      "الرباط",
      "الخميسات",
      "تمارة الصخيرات",
      "سيدي قاسم",
      "سيدي سليمان",
      "القنيطرة"
    ]
  },
  {
    address: " شارع سيدي عبد الرحمان صندوق البريد 12365  الهاتف:0522919479/65/71",
    name: "الدار البيضاء سطات",
    villes: [
      "الفداء مرس السلطان",
      "النواصر",
      "عين الشق",
      "الحي الحسني",
      "الحي المحمدي",
      "سيدي البرنوصي",
      "ابن مسيك",
      "المحمدية",
      "مديونة",
      "انفا",
      "مولاي رشيد سيدي عثمان",
      "سطات",
      "بنسليمان",
      "برشيد",
      "سيدي بنور",
      "عين السبع",
      "الجديدة"
    ]
  },
  {
    address: "حـــي الــمســيــرة وجــــدة الهاتف : 0536685018",
    name: "الجهة الشرقية",
    villes: [
      "الناظور",
      "دريوش",
      "تاوريرت",
      "جرادة",
      "بركان",
      "فكيك",
      "وجدة انكاد",
      "جرسيف"
    ]
  },
  {
    address: "شارع محمد السادس - ص.ب: 427 - كلميم 81000– الهاتف :28 87 35 00 05",
    name: "كلميم  واد نون",
    villes: ["أسا - الزاك", "كلميم", "طانطان", "سيدي افني"]
  },
  {
    address: "شارع مولاي رشيد (طريق صفرو) - ص.ب-2342 - فاس - الهاتف: 05.35.65.76.25/05.35.64.20.23",
    name: "فاس مكناس",
    villes: [
      "بولمان",
      "مولاي يعقوب",
      "صفرو",
      "فاس",
      "تاونات",
      "تازة",
      "الحاجب",
      "مكناس",
      "افران"
    ]
  },
  { name: "الداخلة وادي الذهب", 
    address: "شارع محمد فاضل السملالي - الداخلة​ الهاتف : 0528931234",
    villes: ["وادي الذهب", "الداخلة", "اوسرد"] },
  {
    address: "تطوان الهاتف : 0539970905",
    name: "طنجة تطوان الحسيمة",
    villes: [
      "المضيق الفنيدق",
      "شفشاون",
      "العرائش",
      "تطوان",
      "طنجة اصيلة",
      "القصرالكبير",
      "وزان",
      "الفحص انجرة",
      "الحسيمة"
    ]
  },
  {
    address: "محج محمد السادس – ص.ب: 688 - العيون​​ الهاتف ​​: 61/62/63 00 99 28 05 ",
    name: "العيون الساقية الحمراء",
    villes: ["السمارة", "بوجدور", "العيون", "طرفاية"]
  },
  {
    address: "زنقة أبو عبيدة الداوديات مراكش - الهاتف :​ 0524304238",
    name: "مراكش آسفي",
    villes: [
      "مراكش",
      "الحوز",
      "الصويرة",
      "شيشاوة",
      "قلعة السراغنة",
      "الرحامنة",
      "سيدي يوسف بن علي",
      "اليوسفية",
      "اسفي"
    ]
  },
  {
    address: "شارع القدس بني ملال. الهاتف: 01-24-48-23-05 / 22-38-48-23-05",
    name: "بني ملال خنيفرة",
    villes: ["بني ملال", "ازيلال", "الفقيه بن صالح", "خنيفرة", "خريبكة"]
  },
  {
    address: "شارع مولاي يوسف،حي النهضة، ص.ب: S/7 أكادير الهاتف: 0528388383",
    name: "سوس ماسة",
    villes: [
      "اكادير ادا وتنان",
      "تيزنيت",
      "شتوكة ايت باهة",
      "تارودانت",
      "انزكان",
      "طاطا"
    ]
  },
  {
    address: "شارع الحسن 2 ، طريق مكناس ، 52000 الرشيدية",
    name: "درعة تافيلالت",
    villes: ["ميدلت", "الرشيدية", "زاكورة", "تنغير", "ورززات"]
  }
];
